module.exports = __webpack_public_path__ + "static/media/arrow-up_24x24.49bbc29e.svg";